import React, { useRef, useState, useEffect } from 'react';

// Canvas de assinatura — desenho livre com mouse ou touque.
// onChange(base64PngOuNull) é chamado a cada traço e ao limpar.
export default function AssinaturaCanvas({ label, onChange, largura = 300, altura = 120 }) {
  const canvasRef = useRef(null);
  const desenhando = useRef(false);
  const [temTraco, setTemTraco] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    // Ajusta resolução real do canvas (evita traço borrado em telas retina)
    const dpr = window.devicePixelRatio || 1;
    canvas.width = largura * dpr;
    canvas.height = altura * dpr;
    canvas.style.width = largura + 'px';
    canvas.style.height = altura + 'px';
    const ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    ctx.strokeStyle = '#1A2233';
    ctx.lineWidth = 2;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
  }, [largura, altura]);

  function posicao(e) {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const ponto = e.touches ? e.touches[0] : e;
    return { x: ponto.clientX - rect.left, y: ponto.clientY - rect.top };
  }

  function iniciar(e) {
    e.preventDefault();
    desenhando.current = true;
    const { x, y } = posicao(e);
    const ctx = canvasRef.current.getContext('2d');
    ctx.beginPath();
    ctx.moveTo(x, y);
  }

  function mover(e) {
    if (!desenhando.current) return;
    e.preventDefault();
    const { x, y } = posicao(e);
    const ctx = canvasRef.current.getContext('2d');
    ctx.lineTo(x, y);
    ctx.stroke();
    if (!temTraco) setTemTraco(true);
  }

  function finalizarTraco() {
    if (!desenhando.current) return;
    desenhando.current = false;
    if (temTraco) onChange(canvasRef.current.toDataURL('image/png'));
  }

  function limpar() {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    setTemTraco(false);
    onChange(null);
  }

  return (
    <div>
      {label && <div style={{ fontSize: 12, fontWeight: 700, color: '#6b7a8d', marginBottom: 6 }}>{label}</div>}
      <div style={{ border: '1.5px dashed #d4dde8', borderRadius: 10, background: '#fafbfc', display: 'inline-block' }}>
        <canvas
          ref={canvasRef}
          style={{ touchAction: 'none', cursor: 'crosshair', display: 'block' }}
          onMouseDown={iniciar} onMouseMove={mover} onMouseUp={finalizarTraco} onMouseLeave={finalizarTraco}
          onTouchStart={iniciar} onTouchMove={mover} onTouchEnd={finalizarTraco}
        />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 6 }}>
        <span style={{ fontSize: 11, color: '#9aa5b1' }}>{temTraco ? 'Assinado' : 'Opcional — desenhe acima para assinar'}</span>
        <button type="button" onClick={limpar} style={{ background: 'none', border: 'none', color: '#D85A30', fontSize: 12, fontWeight: 600, cursor: 'pointer', padding: 0 }}>
          Limpar
        </button>
      </div>
    </div>
  );
}
